import {
    Box,
    chakra,
    Container,
    Image,
    Stack,
    Text,
    useColorModeValue,
    useBreakpointValue,
    VisuallyHidden,
    Center,
    Grid,
    Flex,
    SimpleGrid, GridItem
} from '@chakra-ui/react';
import { trackClick } from '../ga';
export default function NotFound() {
    return (
        <Box bgGradient="linear(to-b, #ffffff, #2f4280)" py={16} px={6}    onClick={() => trackClick(`Clicked not found page `)}>
        <Container textAlign='center' maxW={'7xl'} height={['100%', '500px']} position="relative" overflow='hidden'>
            <Container maxW={'6xl'} py={10}>
                {/* Header */}
                <Center mb={10}>
                    <Text color={useColorModeValue('#185a9e', '#40c1c3')} fontSize="3xl" fontWeight="bold">
                        404
                    </Text>
                </Center>
                <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: "5px", md: "30px" }}>
                    <GridItem colSpan={{ base: 1, md: 3 }}>
                        <Box p='50px' fontWeight='bold'>
                            <Text lineClamp="2">
                                You do not have permission to access this page
                            </Text>
                        </Box>
                    </GridItem>
                </SimpleGrid>
            </Container>
        </Container>
      </Box>
    );
}